import React, { FunctionComponent } from 'react'
import * as S from './styled'

type OwnProps = {
  clickHandler: (option: string) => void
  options: { func: string; name: string }[]
}

type Props = OwnProps

const ActionMenu: FunctionComponent<Props> = ({ clickHandler, options }) => {
  return (
    <S.Wrapper>
      {options.map(opt => (
        <S.Button key={opt.func} onClick={() => clickHandler(opt.func)}>
          {opt.name}
        </S.Button>
      ))}

      {/* <S.Button onClick={() => clickHandler('update')}>Ändra</S.Button> */}
    </S.Wrapper>
  )
}

export default ActionMenu
